
import React, { Component } from "react";


class Registrar extends Component {

    state = {
        tarjeta: '0',
        color: '#ffffff',
        img: '',
        nombre: '',
        rfc: 'XAXX010101000',
        calle: 'SIN CALLE',
        no_ext: '0',
        no_int: 0,
        colonia: 'SIN COLONIA',
        referencia: 'SIN DATOS',
        ciudad: 'SIN CIUDAD',
        estado: 'SIN ESTADO',
        email: 'correo@example.com',
        clasificacion: 0,
        telefono: '',
        tipo: 0,
        cp: '86000',
        sucursal: 0,
        regimen_fiscal: 11,
        sucursales: [],
        clasificaciones: [],
        tipos: [],
        regimenes: [],
        code: 0,
        loading: false
    }

    async componentDidMount() {
        fetch("http://monedero.ipsservicios.com.mx/consultar.php",
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: "POST",
                body: JSON.stringify({
                    'accion': 'datos_form'
                })
            }).then(res => res.json()).then(result => {
                console.log(result);
                this.setState({
                    clasificaciones: result.clasificacion,
                    sucursales: result.sucursales,
                    regimenes: result.regimenes
                })
            }).catch(error => {
                console.log(error);
            });
    }

    registrarDatos = e => {
        e.preventDefault();


        if (this.state.clasificacion === 0) {
            alert("Seleccione una clasificación");
        } else if (this.state.tipo === 0) {
            alert("Seleccione un tipo");
        } else if (this.state.sucursal === 0) {
            alert("Seleccione una sucursal");
        } else {
            this.setState({
                loading: true
            })

            fetch("http://monedero.ipsservicios.com.mx/agregar.php",
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    method: "POST",
                    body: JSON.stringify({
                        nombre: this.state.nombre,
                        rfc: this.state.rfc,
                        calle: this.state.calle,
                        no_ext: this.state.no_ext,
                        no_int: this.state.no_int,
                        colonia: this.state.colonia,
                        referencia: this.state.referencia,
                        ciudad: this.state.ciudad,
                        estado: this.state.estado,
                        email: this.state.email,
                        telefono: this.state.telefono,
                        clasificacion: this.state.clasificacion,
                        tipo: this.state.tipo,
                        cp: this.state.cp,
                        regimen_fiscal: this.state.regimen_fiscal,
                        sucursal: this.state.sucursal
                    })
                }
            ).then(res => res.json()).then(result => {
                this.setState({
                    loading: false
                })
                if (result.codigo === "120") {
                    alert("Existe un Monedero con ese Cliente y Correo")
                } else {
                    this.num_monedero(this.state.nombre, this.state.email);

                    this.setState({
                        code: 200
                    })
                    if (this.state.clasificacion == 1 || this.state.clasificacion == 2) {
                        this.setState({
                            img: './plus.jpeg',
                            color: 'white'
                        })
                    } else if (this.state.clasificacion == 3) {
                        this.setState({
                            img: './student.jpeg',
                            color: 'black'
                        })
                    } if (this.state.clasificacion == 4) {
                        this.setState({
                            img: './business.jpeg',
                            color: 'white'
                        })
                    }
                }
                console.log(result);
            }).catch(error => {
                console.log(error);
            });
        }
    }

    num_monedero = (nombre, correo) => {

        fetch("http://monedero.ipsservicios.com.mx/consultar.php",
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: "POST",
                body: JSON.stringify({
                    'accion': 'monedoro_cliente',
                    'nombre': nombre,
                    'correo': correo
                })
            }).then(res => res.json()).then(result => {
                console.log(result);
                if (result) {
                    this.setState({
                        tarjeta: result.MONEDERO
                    });
                }
            }).catch(error => {
                console.log(error);
            });
    }

    tipos_cb = (id) => {

        fetch("http://monedero.ipsservicios.com.mx/consultar.php",
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: "POST",
                body: JSON.stringify({
                    'accion': 'tipo',
                    'clasi_id': id
                })
            }
        ).then(res => res.json()).then(result => {
            console.log(result.tipos);
            this.setState({
                tipos: result.tipos
            })
        }).catch(error => {
            console.log(error);
        });
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })

        if (e.target.name === "clasificacion") {
            this.tipos_cb(e.target.value);
        }
    }

    limpiar = () => {
        this.setState({
            img: '',
            nombre: '',
            rfc: 'XAXX010101000',
            calle: 'SIN CALLE',
            no_ext: '0',
            no_int: 0,
            colonia: 'SIN COLONIA',
            referencia: 'SIN DATOS',
            ciudad: 'SIN CIUDAD',
            estado: 'SIN ESTADO',
            email: 'correo@example.com',
            telefono: '',
            cp: '86000',
            regimen_fiscal: 11,
            code: 0,
            loading: false
        })
    }

    render() {

        var card_number = {
            color: this.state.color,
            marginTop: '-120px',
            fontSize: '24px',
            'font-family': 'PT Mono, monospace',
            'align-items': 'flex-end',
            'letter-spacing': '10px'
        }

        return (
            <div>

                {
                    (this.state.code === 200) ?
                        <div className="mt-2 text-center">
                            <h6 className="display-6"><b>Felicidades</b>, Tú Monedero ha sido creado con éxito!</h6>
                            <img src={this.state.img} height="300" /> <br />
                            <p style={card_number} className="mb-5">{this.state.tarjeta}</p>
                            <button type="button" className="btn btn-outline-dark mt-5" data-bs-dismiss="modal" onClick={this.limpiar}>Cerrar</button>
                        </div>
                        :
                        <form onSubmit={this.registrarDatos}>
                            <div className="row">
                                <div className="col-sm-7 col-xs-12">
                                    <label>Nombre *</label>
                                    <input type="text" required onChange={this.onChange} name="nombre" placeholder="Nombre" className="form-control form-control-sm" />
                                </div>
                                <div className="col-sm-5 col-xs-12">
                                    <label>RFC</label>
                                    <input type="text" onChange={this.onChange} name="rfc" value={this.state.rfc} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-7 col-xs-12">
                                    <label>Calle</label>
                                    <input type="text" name="calle" onChange={this.onChange} value={this.state.calle} className="form-control form-control-sm" />
                                </div>
                                <div className="col-sm-5 col-xs-12">
                                    <div className="row">
                                        <div className="col-sm-6 col-xs-12">
                                            <label>No.Ext</label>
                                            <input type="text" name="no_ext" onChange={this.onChange} value={this.state.no_ext} className="form-control form-control-sm" />
                                        </div>
                                        <div className="col-sm-6 col-xs-12">
                                            <label>No.Int</label>
                                            <input type="text" name="no_int" onChange={this.onChange} className="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-7 col-xs-12">
                                    <div className="row">
                                        <div className="col-sm-6 col-xs-12">
                                            <label>Colonia</label>
                                            <input type="text" name="colonia" onChange={this.onChange} value={this.state.colonia} className="form-control form-control-sm" />
                                        </div>
                                        <div className="col-sm-6 col-xs-12">
                                            <label>Referencia</label>
                                            <input type="text" name="referencia" onChange={this.onChange} value={this.state.referencia} className="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-5 col-xs-12">
                                    <div className="row">
                                        <div className="col-sm-6 col-xs-12">
                                            <label>Ciudad</label>
                                            <input type="text" name="ciudad" onChange={this.onChange} value={this.state.ciudad} className="form-control form-control-sm" />
                                        </div>
                                        <div className="col-sm-6 col-xs-12">
                                            <label>Estado</label>
                                            <input type="text" name="estado" onChange={this.onChange} value={this.state.estado} className="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-7 col-xs-12">
                                    <label>Regimen Fiscal</label>
                                    <select className="form-control form-control-sm" name="regimen_fiscal" onChange={this.onChange}>
                                        {this.state.regimenes.map(rg => {
                                            if (rg.regimen_id === 11) {
                                                return (<option selected value={rg.regimen_id}>{rg.nombre}</option>)
                                            } else {
                                                return (<option value={rg.regimen_id}>{rg.nombre}</option>)
                                            }

                                        })}
                                    </select>
                                </div>
                                <div className="col-sm-5 col-xs-12">
                                    <div className="row">
                                        <div className="col-sm-6 col-xs-12">
                                            <label>CP</label>
                                            <input type="text" name="cp" onChange={this.onChange} value={this.state.cp} className="form-control form-control-sm" />
                                        </div>
                                        <div className="col-sm-6 col-xs-12">
                                            <label>E-mail*</label>
                                            <input type="email" required name="email" onChange={this.onChange} value={this.state.email} className="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-sm-3 col-xs-12">
                                    <label>Telefono*</label>
                                    <input type="number" required name="telefono" onChange={this.onChange} className="form-control form-control-sm" />
                                </div>
                                <div className="col-sm-3 col-xs-12">
                                    <label>Clasificación</label>
                                    <select className="form-control form-control-sm" name="clasificacion" onChange={this.onChange}>
                                        <option value="0">Seleccionar</option>
                                        {this.state.clasificaciones.map(cl => {
                                            return (<option value={cl.clasificacion_id}>{cl.nombre}</option>)
                                        })}
                                    </select>
                                </div>
                                <div className="col-sm-3 col-xs-12">
                                    <label>Tipo</label>
                                    <select className="form-control form-control-sm" name="tipo" onChange={this.onChange}>
                                        <option value="0">Seleccionar</option>
                                        {this.state.tipos.map(tp => {
                                            return (<option value={tp.tipo_id}>{tp.descripcion}</option>)
                                        })}
                                    </select>
                                </div>
                                <div className="col-sm-3 col-xs-12">
                                    <label>Sucursal</label>
                                    <select className="form-control form-control-sm" onChange={this.onChange} name="sucursal" >
                                        <option value="0">Seleccionar</option>
                                        {this.state.sucursales.map(s => {
                                            return (<option value={s.sucursal_id}>{s.nombre}</option>)
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <button type="button" class="btn btn-outline-dark btn-sm mt-4" data-bs-dismiss="modal">Salir</button>
                                    <button type="submit" className="btn btn-outline-success btn-sm mt-4" >Registrar</button>
                                </div>
                                <div className="col-sm-6">
                                    {
                                        (this.state.loading) ?
                                            <div className="spinner-border float-lg-end mt-3" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            :
                                            <div></div>
                                    }
                                </div>
                            </div>

                        </form>
                }





            </div>
        )
    }
}

export default Registrar;